import { API } from './axios';
import { URLS } from './Urls';

export const productService = {
  // Récupérer tous les produits (gestion de la pagination)
  getAllProducts: async (searchQuery = '') => {
    try {
      console.log('Récupération de tous les produits...');
      
      let allProducts = [];
      const seenIds = new Set();
      let page = 1;
      let hasNextPage = true;
      
      while (hasNextPage && page <= 50) { // Limite de sécurité à 50 pages
        console.log(`Récupération de la page ${page}...`);
        
        const response = await API.get(URLS.PRODUCT.getAllProducts(), {
          params: {
            page_size: 100, // Récupérer 100 produits par page pour optimiser
            page: page,
            search: searchQuery
          }
        });
        
        
        const data = response.data;
        console.log(`Page ${page} - Résultats reçus:`, data.items ? data.items.length : 0);
        console.log(`Page ${page} - Total count:`, data.total_count);
        
        if (data.items && data.items.length > 0) {
          // Filtrer les doublons basés sur l'ID
          const newProducts = data.items.filter(product => {
            if (seenIds.has(product.id)) {
              console.warn(`Doublon détecté - ID: ${product.id}`);
              return false;
            }
            seenIds.add(product.id);
            return true;
          });
          
          allProducts = allProducts.concat(newProducts);
          console.log(`Page ${page} - Nouveaux produits ajoutés:`, newProducts.length);
        }
        
        // Vérifier s'il y a une page suivante
        hasNextPage = data.next !== null && data.next !== undefined && data.next !== '';
        
        // Si on n'a pas de résultats sur cette page, arrêter
        if (!data.items || data.items.length === 0) {
          console.log(`Page ${page} vide, arrêt de la récupération`);
          break;
        }
        
        page++;
      }
      
      console.log(`Total des produits récupérés (sans doublons): ${allProducts.length}`);
      
      return {
        items: allProducts,
        total_count: allProducts.length,
        search_criteria: {
          page_size: 100,
          current_page: 1
        }
      };
    } catch (error) {
      console.error('Erreur lors de la récupération de tous les produits:', error);
      throw error;
    }
  },

  // Récupérer les produits avec pagination normale (pour la recherche)
  getProducts: async (searchQuery = '', page = 1, pageSize = 10) => {
    try {
      const response = await API.get(URLS.PRODUCT.getAllProducts(), {
        params: {
          search: searchQuery,
          page: page,
          page_size: pageSize
        }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des produits:', error);
      throw error;
    }
  }
};
